<template>
  <div class="container">
    <!-- 判断 appointments 是否为空 -->
    <div v-if="appointments.length === 0" class="no-data">
      <span>无表单申请</span>
    </div>

    <div
      v-for="(item, index) in appointments"
      :key="index"
      class="appointment-item"
      :class="{ clickable: item.zhuangtai === '未审批' }"
      @click="item.zhuangtai === '未审批' ? openApprovalDialog(item) : null"
    >
      <div class="appointment-header">
        <span class="name">{{ item.fangkeName }}</span>
        <span class="phone-number">{{ item.fangkePhone }}</span>
        <span class="status">{{ item.zhuangtai }}</span>
      </div>
      <div class="divider"></div>
      <div class="appointment-time">
        <span>接访者姓名: {{ item.beifangName }}</span>
        <span>到访原因: {{ item.reason }}</span>
        <span>到访人数: {{ item.daofangNumber }}</span>
        <span>拜访时间: {{ item.readTime }}</span>
        <span v-if="item.errorReason">不通过原因: {{ item.errorReason }}</span>
        <!-- 审批流程 -->
        <div class="approval-process">
          <div class="approval-step">
            <span :class="getIconClass1(item.zhuangtai,item.checkErji)" class="icon"></span>
            <span class="status">{{ firstApprovalName }} · {{ item.checkErji === '审批不通过' ? '审批通过' : (item.zhuangtai === '审批中' ? '审批通过' : item.zhuangtai) }}</span>
          </div>
        
          <div v-if="secondApproval1" class="approval-step">
            <span :class="getIconClass(item.checkErji)" class="icon"></span>
            <span class="status">{{ secondApprovalName }} · {{ item.checkErji }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 审批弹窗 -->
    <el-dialog
      title="审批操作"
      :visible.sync="approvalDialogVisible"
      width="90%"
      class="approval-dialog"
    >
      <div class="dialog-content">
        <p>访客姓名: {{ currentAppointment.fangkeName }}</p>
        <p>访客手机号: {{ currentAppointment.fangkePhone }}</p>
        <p>访客单位: {{ currentAppointment.qiyeName }}</p>
        <p>接访人姓名: {{ currentAppointment.beifangName }}</p>
        <p>到访原因: {{ currentAppointment.reason }}</p>
        <p>到访人数: {{ currentAppointment.daofangNumber }}</p>
        <p>拜访时间: {{ currentAppointment.readTime }}</p>
      </div>
      <el-input
        v-model="rejectReason"
        type="textarea"
        placeholder="请输入不通过原因（仅在选择不通过时必填）"
        :rows="2"
      ></el-input>
      <div slot="footer" class="dialog-footer">
        <el-button type="success" @click="approveAppointment(true)" class="dialog-button">通过</el-button>
        <el-button type="danger" @click="approveAppointment(false)" class="dialog-button">不通过</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "AppointmentList",
  data() {
    return {
      appointments: [], // 初始为空，通过 API 获取数据
      approvalDialogVisible: false, // 控制审批弹窗的显示
      currentAppointment: {}, // 当前正在审批的预约项
      rejectReason: "", // 不通过原因
      isApproved: true, // 默认为通过
      firstApproval:'',//一级审批是否通过
      firstApprovalName:'',//一级审批人的名字
      secondApproval:false,//二级审批是否通过
      secondApprovalName:'',//二级审批人的名字
      secondApproval1:true //是否有二级审批人
    };
  },
  created() {
    this.fetchAppointments(); // 在组件创建时调用 API 获取数据
    // 获取一级审批人姓名
    this.getFirstApprovalName();
    //判断是否有二级审批人
    this.checkErjiShenpi();
    if(this.secondApproval1){
      this.getErjiShenpi();
    }
  },
  methods: {
    fetchAppointments() {
      // 调用 API 获取 appointments 数据
      this.$axios.get("/api/chaxun_fangke_form") // 假设 API 地址为 /api/chaxun_fangke_form
        .then(response => {
          console.log(response.data.data)
          this.appointments = response.data.data.map(item =>{
            //替换T
            if(item.readTime){
              item.readTime = item.readTime.replace('T',' ');
            }
            console.log(this.appointments.length)

            return item;
          }).reverse(); // 假设返回的数据是一个数组
        })
        .catch(error => {
          console.error("Error fetching appointments:", error);
          this.$message.error("加载预约信息失败，请稍后再试");
        });
    },
    getFirstApprovalName() {
      this.$axios.get(`/api/get_yiji_shenpi`)
        .then(response => {
          if (response.data.code === 0) {
            const name = response.data.data;
            console.log(name)
            this.firstApprovalName=name
          }
        })
        .catch(error => {
          console.error("Error fetching approval name:", error);
          this.$message.error("加载审批人姓名失败，请稍后再试");
        });
    },
    checkErjiShenpi() {
      this.$axios.get(`/api/check_erji_shenpi`)
        .then(response => {
          if (response.data.code === 0) {
            const erji = response.data.data;
            console.log(erji)
            this.secondApproval1=erji
          }
        })
        .catch(error => {
          console.error("Error fetching approval name:", error);
          this.$message.error("加载审批人姓名失败，请稍后再试");
        });
    },
    getErjiShenpi() {
      this.$axios.get(`/api/get_erji_shenpi`)
        .then(response => {
          if (response.data.code === 0) {
            const erji = response.data.data;
            console.log(erji)
            this.secondApprovalName=erji
          }
        })
        .catch(error => {
          console.error("Error fetching approval name:", error);
          this.$message.error("加载审批人姓名失败，请稍后再试");
        });
    },
    openApprovalDialog(item) {
      this.currentAppointment = item; // 设置当前审批项
      this.rejectReason = ""; // 清空不通过原因
      this.isApproved = true; // 默认为通过
      this.approvalDialogVisible = true; // 打开审批弹窗
    },
    approveAppointment(isApproved) {
      const id = this.currentAppointment.id; // 获取当前审批项的 ID

      if (isApproved) {
        // 调用审批通过的 API
        this.$axios.post("/api/fangke_form/change0",  id )
          .then(response => {
            // console.log(response)
            if(response.data.code==0){
               this.$message.success("审批通过成功");
               //刷新页面
               this.fetchAppointments();
               return;
            }
            this.$message.error("审批失败")
          })
          .catch(error => {
            console.error("Error approving appointment:", error);
            this.$message.error("审批失败，请稍后再试");
          });
      } else {
        // 检查是否输入了不通过原因
        if (!this.rejectReason.trim()) {
          this.$message.error("请输入不通过原因");
          return;
        }

        // 调用审批不通过的 API
        this.$axios.post("/api/fangke_form/change1", { id, errReason: this.rejectReason })
          .then(response => {
            console.log(response)
            this.$message.success("审批不通过成功");
            this.fetchAppointments();
          })
          .catch(error => {
            console.error("Error rejecting appointment:", error);
            this.$message.error("审批失败，请稍后再试");
          });
      }

      this.approvalDialogVisible = false; // 关闭弹窗
      this.fetchAppointments(); // 刷新数据
    },
    getIconClass(isApproved) {
      if(isApproved=='审批通过'){
        return 'icon-approved'
      }
      if(isApproved=='审批不通过'){
        return 'icon-rejected'
      }
      if(isApproved=='未审批'){
        return 'icon-un'
      }
      
    },
    getIconClass1(isApproved,checkErji) {
      if(isApproved=='审批中'){
        return 'icon-approved'
      }
      if(isApproved=='审批通过'){
        return 'icon-approved'
      }
      if(isApproved=='审批不通过'){
        if(checkErji=='审批不通过'){
          return 'icon-approved'
        }
        return 'icon-rejected'
      }
      if(isApproved=='未审批'){
        return 'icon-un'
      }
      
    },
  }
  
};
</script>

<style scoped>
.container {
  padding: 16px;
  background-color: #fff;
  height: 100%;
}

.no-data {
  text-align: center;
  color: #999;
  font-size: 16px;
}
.appointment-item {
  background-color: #fff;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;
  box-shadow: 10px 10px 10px rgba(0, 123, 255, 0.1); /* 添加阴影效果 */
  cursor: default; /* 默认不可点击 */
}

.appointment-item.clickable {
  cursor: pointer; /* 可点击时显示手型图标 */
  transition: background-color 0.3s;
}

.appointment-item.clickable:hover {
  background-color: #f0f8ff; /* 鼠标悬停时的背景色 */
}

.appointment-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
}

.appointment-header .name {
  font-weight: bold;
  font-size: 18px;
}

.appointment-header .phone-number {
  color: #007bff;
}

.appointment-header .status {
  color: #5cb85c;
}

.divider {
  border-bottom: 1px solid #ddd;
  margin-bottom: 12px;
}

.appointment-time span {
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  color: #333;
}

/* 审批弹窗样式 */
.approval-dialog .dialog-content {
  font-size: 16px;
  color: #333;
  margin-bottom: 20px;
}

.dialog-footer {
  display: flex;
  justify-content: center;
  gap: 10px;
}

.dialog-button {
  padding: 10px 20px;
  font-size: 14px;
}

.approval-process {
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.approval-step {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.approval-step .icon {
  margin-right: 8px;
  font-size: 15px;
  border-radius: 50%;
  width: 15px;
  height: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.icon-approved {
  background-color: #007bff;
  color: #fff;
}

.icon-rejected {
  background-color: #ff4d4f;
  color: #fff;
}

.icon-un {
  background-color: #756d6d;
  color: #fff;
}


.icon-pending {
  background-color: #fff;
  border: 1px solid #000;
}

.approval-step .status {
  margin-right: 8px;
  font-size: 14px;
  font-weight: bold;
}

.approval-step .avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-right: 8px;
}

.approval-step .name {
  font-size: 14px;
}

.connector {
  height: 100%;
  width: 1px;
  background-color: #000;
  margin: 0 8px;
}
</style>